<template>
  <div class="d-flex justify-content-between align-items-center w-100 ml-2">
    <b-spinner class="ml-2" label="Spinning" v-if="isLoading"></b-spinner>
    <div v-else>
      <i class="fa-chevron-left fas icon-xl mr-2 navigationIcons" @click="$emit('go-up')"></i>
      <i class="fa-chevron-right fas icon-xl mr-2 navigationIcons" @click="$emit('go-down')"></i>
    </div>
    <div v-if="isLoading"><b-spinner class="ml-2" label="Spinning"></b-spinner></div>
    <div v-else-if="reisetermin" style="display: flex; justify-content: center; flex-direction: column">
      <a
        :href="'#/reisetermine/' + reisetermin.id + '?vorgangdetailstab=fluege&scrollToFlugdaten=true'"
        target="_blank"
      >
        <h4 class="mb-0">
          <b>{{ reisetermin?.reiseterminkuerzel }}</b>
        </h4>
      </a>

      <span style="font-size: 1rem" v-if="reisetermin?.ursprungsreiseterminId">
        Ehemals:
        <a target="blank" :href="'/#/reisetermine/' + reisetermin.ursprungsreiseterminId">
          {{ reisetermin.ursprungsreisetermin?.reiseterminkuerzel }}
        </a>
      </span>
      <span style="font-size: 1rem" v-if="reisetermin?.ersatztermin">
        Ersatztermin:
        <a target="blank" :href="'/#/reisetermine/' + reisetermin.ersatztermin.id">
          {{ reisetermin.ersatztermin?.reiseterminkuerzel }}
        </a>
      </span>
    </div>
    <div>
      <b-button
        v-if="reisetermin"
        class="btn btn-icon ml-auto mr-2 icon-button"
        size="sm"
        title="Reisestammdaten"
        :href="
          '#/reisen/' +
          reisetermin.reise.reisekuerzel +
          '/reisestammdaten?reiseterminAbreisedatum=' +
          reisetermin.abreisedatum.substring(0, 10)
        "
        target="_blank"
      >
        <i class="flaticon-edit" />
      </b-button>
      <div
        class="icon-button d-inline-flex justify-content-center align-middle mr-2 ml-auto"
        style="width: 32px; height: 32px"
        @click="$emit('aufgabe-erstellen')"
        v-b-modal.modalAufgabeEdit
        v-b-tooltip.hover.bottom
        :title="'Aufgabe erstellen'"
      >
        <span class="d-flex align-items-center"><ListChecks :size="20" /></span>
      </div>
      <b-button
        class="dialog-btn mr-4"
        size="sm"
        @click="$emit('save')"
        :variant="disableSpeichernButton ? 'secondary' : 'primary'"
        :disabled="disableSpeichernButton"
      >
        Speichern
      </b-button>
      <i class="fas fa-times m-3 navigationIcons" @click="$emit('close')"></i>
    </div>
  </div>
</template>

<script>
import { ListChecks } from 'lucide-vue';

export default {
  name: 'SidebarFlugplanungHeader',
  components: { ListChecks },
  props: {
    // Steuert die Ladeanzeige im Header
    isLoading: { type: Boolean, default: false },
    // Der aktive Reisetermin für Titel, Links und Reisestammdaten-Button
    reisetermin: { type: Object, default: null },
    // Deaktiviert den Speichern-Button, wenn keine speicherbaren Änderungen vorliegen
    disableSpeichernButton: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.btn.btn-icon.icon-button {
  width: 32px;
  height: 32px;
}

.navigationIcons {
  color: black;
}

.navigationIcons:hover {
  color: #0d6efd;
  cursor: pointer;
}
</style>
